Drupal.behaviors.forms = {
  attach: function attach(context, settings) {
    // generic webform form class used for scoring tables.
    var calculateForm = document.querySelector('.score-table');
    var calculatedTotal = document.querySelector('.calculated-total div');

    if (!calculateForm) {
      return;
    }

    calculateForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var total_score = calculateTotalScore();
      update_total(total_score);
    });

    function calculateTotalScore() {
      var total_score = 0; // get all select elements with a custom class of score.

      var select_elements = document.querySelectorAll('.score');
      select_elements.forEach(function (select) {
        var selectedValue = parseInt(select.value, 10);

        if (!isNaN(selectedValue)) {
          total_score += selectedValue;
        }
      });
      return total_score;
    }

    function update_total(total_score) {
      calculatedTotal.innerHTML = total_score;
    }
  }
};